module.exports = __webpack_public_path__ + "img/kong-building.ef1f0517.svg";